<template>
    <ul class="menu">
        <li v-for="(menu, index) in menuList" :key="index">
            <router-link :to="menu.route" active-class="active">{{menu.name}}</router-link>
        </li>
    </ul>
</template>
<script>
export default {
    props: {
        menuList: {
            type: Array,
            default() {
                return []
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    margin: 0;
    padding: 0;
    background: #fff;
    box-shadow: 0 0 8px 0 rgba(143, 170, 253, 0.12), 0 8px 8px 0 rgba(143, 170, 253, 0.10);
    border-radius: 2px;
    display: inline-block;
    vertical-align: top;

    li {
        width: 140px;
        height: 46px;
        line-height: 46px;
        list-style: none;
    }

    li>a {
        display: block;
        height: 100%;
        padding-left: 38px;
        text-decoration: none;
        font-size: 14px;
        color: #5C667E;
        background-position: 7px 11px;
        background-repeat: no-repeat;
        background-size: 24px;
        position: relative;

        &.active {
            color: #8FA9FE;
            background-size: 24px;

            &:before {
                position: absolute;
                left: 0;
                top: 14px;
                content: "";
                display: block;
                width: 4px;
                height: 16px;
                background: #8FAAFD;
                border-radius: 2px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue